import { create } from "zustand";

type NavBarStore = {
  drawerWidth: number;
  setDrawerWidth: (width: number) => void;
};

export const useNavBarStore = create<NavBarStore>((set) => ({
  drawerWidth: 250, // default to full drawer
  setDrawerWidth: (width: number) => set({ drawerWidth: width }),
}));
